module.exports = __webpack_public_path__ + "static/img/na.f5877d6e.svg";